import { createContext } from "react";

export type NavigationLevel = "dashboard" | "goal" | "task" | "subtask";

export interface ForwardHistory {
  level: Exclude<NavigationLevel, "dashboard">;
  activeGoalId: string | null;
  activeTaskId: string | null;
  activeSubTaskId: string | null;
}

export interface NavigationState {
  currentLevel: NavigationLevel;
  activeGoalId: string | null;
  activeTaskId: string | null;
  activeSubTaskId: string | null;
  forwardHistoryMode: boolean;
  isEditing: boolean;
  forwardHistory: ForwardHistory | null;
}

export interface NavigateToPayload {
  goalId?: string | null;
  taskId?: string | null;
  subTaskId?: string | null;
  preserveForwardHistory?: boolean;
}

export interface NavigationContextValue extends NavigationState {
  canGoBack: boolean;
  canGoForward: boolean;
  goToDashboard: () => void;
  goToGoal: (goalId: string) => void;
  goToTask: (goalId: string, taskId: string) => void;
  goToSubTask: (goalId: string, taskId: string, subTaskId: string) => void;
  jumpToLevel: (
    level: NavigationLevel,
    ids?: { goalId?: string | null; taskId?: string | null; subTaskId?: string | null },
  ) => void;
  levelDown: (payload?: NavigateToPayload) => void;
  goForward: () => void;
  goBack: () => void;
  setEditing: (isEditing: boolean) => void;
  toggleEditing: () => void;
  resetNavigation: () => void;
}

export const NavigationContext = createContext<NavigationContextValue | undefined>(undefined);
